import { useEffect, useState } from 'react'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import 'swiper/css'
import { Swiper, SwiperSlide } from 'swiper/react'
import { PropsType } from '../../@types/etc'
import { SectionDetailType } from '../../@types/home'
import { getCart } from '../../api/cart'
import { getRelatedProduct, getSectionsDetail } from '../../api/home'
import { getOrderList } from '../../api/orderHistory'
import { getLikeProducts, getProductDetail, getRecentProducts } from '../../api/product'
import { sendSetAppsflyerEvent } from '../../js/postMessage'
import { getParsedSessionStorageItem } from '../../js/script'
import { useAppContext } from '../provider/AppProvider'
import { useCartContext } from '../provider/CartProvider'
import { useCommonContext } from '../provider/CommonProvider'
import { CartItem } from './HomeCartItem'

export default function HomeCart({ el, index, category }: PropsType) {
  const [sectionItem, setSectionItem] = useState<SectionDetailType>()
  const [cartItem, setCartItem] = useState<any>([])
  const [like, setLike] = useState<boolean>(false)
  const [priceData, setPriceData] = useState<any>([])
  const [items, setItems] = useState<any>([])
  const { addCart } = useCartContext()
  const { isAppView } = useAppContext()
  const { hasAccessToken } = useCommonContext()

  // 특정 그룹(9889)에 포함된 특정 상품 ID
  const specialProducts = [123937623, 123937622, 123937621]

  useEffect(() => {
    getSectionsDetail(el.sectionNo)
      .then((res) => {
        res.data.map((el: any) => {
          setSectionItem(el)
        })
      })
      .catch((err) => console.log(err))
  }, [like])

  // 라벨로 구분
  useEffect(() => {
    if (sectionItem?.label === '장바구니에 담긴 상품 모듈' && hasAccessToken && cartItem.orderProducts) {
      const fetchProductDetails = async () => {
        try {
          const productDetails = await Promise.all(
            cartItem.orderProducts.map((el: any) => getProductDetail(el.productNo))
          )

          const priceData = productDetails.map((res) => res.data)
          setPriceData((prev: any) => [...prev, ...priceData])
        } catch (err) {
          console.error(err)
        }
      }

      fetchProductDetails()
    }
  }, [sectionItem, cartItem, addCart, hasAccessToken])
  // 라벨로 구분
  useEffect(() => {
    if (sectionItem) {
      if (hasAccessToken) {
        if (sectionItem.label === '장바구니에 담긴 상품 모듈') {
          getCart()
            .then((res) => {
              if (res.data.deliveryGroups.length !== 0) {
                setCartItem(res.data?.deliveryGroups[0])
              } else {
                setCartItem([])
              }
            })
            .catch((err) => console.log(err))
        } else if (sectionItem.label === '최근 본 상품 모듈') {
          getRecentProducts(1)
            .then((res) => {
              setCartItem(res.data.slice(0, 5))
            })
            .catch((err) => console.log(err))
        } else if (sectionItem.label === '최근 본 상품 기반 카테고리 내 다른 상품 모듈') {
          getRecentProducts(1)
            .then((res) => {
              const recentProducts = res.data.slice(0, 5) // 최대 5개의 최근 본 상품만 처리
              // 병렬로 getRelatedProduct 호출
              const relatedProductPromises = recentProducts.map((el: any) =>
                getRelatedProduct(el.productNo).catch((err) => {
                  console.log(err)
                  return [] // 에러 발생 시 빈 배열 반환
                })
              )
              // 모든 getRelatedProduct 호출이 완료되면 처리
              Promise.all(relatedProductPromises)
                .then((relatedProducts) => {
                  // 각 호출의 결과를 병합
                  const productArray = relatedProducts.flat() // 2차원 배열을 1차원 배열로 변환
                  setCartItem(productArray.slice(0, 5)) // 최대 5개의 상품만 설정
                })
                .catch((err) => console.log(err))
            })
            .catch((err) => console.log(err))
        } else if (sectionItem.label === '찜한 목록에 담긴 상품 모듈') {
          getLikeProducts(1)
            .then((res) => {
              setCartItem(res.data.items.slice(0, 5))
            })
            .catch((err) => console.log(err))
        } else if (sectionItem.label === '최근 구매한 상품 모듈') {
          getOrderList()
            .then((res) => {
              const array: any = []
              res.data.items.slice(0, 5).map((el: any) => {
                array.push(...el.orderOptions)
              })
              const unique = removeDuplicates(array)
              setCartItem(unique)
            })
            .catch((err) => {
              console.log(err)
            })
        }
      } else {
        if (sectionItem?.label === '장바구니에 담긴 상품 모듈') {
          const data = getParsedSessionStorageItem('guestCart')
          data?.map((el: any) => {
            getProductDetail(el.productNo)
              .then((res) => {
                setCartItem((prev: any) => [...prev, res.data.baseInfo])
              })
              .catch((err) => {
                console.log(err)
              })
          })
        } else if (sectionItem?.label === '최근 본 상품 모듈') {
          const data = getParsedSessionStorageItem('mallProductNo')
          data
            ?.filter((v: number) => !specialProducts.includes(v))
            ?.map((el: any) => {
              getProductDetail(String(el))
                .then((res) => {
                  setCartItem((prev: any) => [...prev, res.data.baseInfo])
                })
                .catch((err) => {
                  console.log(err)
                })
            })
        } else if (sectionItem?.label === '최근 본 상품 기반 카테고리 내 다른 상품 모듈') {
          const data = getParsedSessionStorageItem('mallProductNo')
          const productArray: any = []
          data
            ?.filter((v: number) => !specialProducts.includes(v))
            ?.map((el: any, idx: number) => {
              if (idx < 5) {
                getRelatedProduct(el).then((res) => {
                  if (!res || !res.data) return
                  productArray.push(...res.data)
                  setCartItem(productArray.slice(0, 5))
                })
              }
            })
        }
      }
    }
  }, [like, sectionItem, addCart])
  function removeDuplicates(products: any) {
    // reduce를 사용하여 중복 제거
    return products.reduce((acc: any, current: any) => {
      // 현재 productNo가 이미 acc에 존재하는지 확인
      if (!acc.some((product: any) => product.productNo === current.productNo)) {
        acc.push(current)
      }
      return acc
    }, [])
  }
  // 100원샵 상품 안보이도록 처리
  useEffect(() => {
    if (!cartItem || !sectionItem) return

    const processItems = () => {
      let devArray: any[] = []

      // 공통 조건 처리
      if (sectionItem.label === '최근 본 상품 모듈' || sectionItem.label === '찜한 목록에 담긴 상품 모듈') {
        devArray = cartItem
          .filter((el: any) => !el.displayCategoryNos?.includes('787334'))
          .filter((el: any) => !el.displayCategoryNos?.includes('797518'))
      } else if (
        sectionItem.label === '최근 구매한 상품 모듈' ||
        sectionItem.label === '최근 본 상품 기반 카테고리 내 다른 상품 모듈'
      ) {
        devArray = cartItem.filter((el: any) => !el.productName?.includes('100원샵'))
      } else {
        devArray = cartItem
      }

      setItems(devArray)
    }

    if (hasAccessToken) {
      processItems()
    } else {
      if (sectionItem.label === '최근 본 상품 모듈') {
        const filteredArray = cartItem
          .filter((el: any) => !el.displayCategoryNos?.includes('787334'))
          .filter((el: any) => !el.displayCategoryNos?.includes('797518'))

        // 여기서 cartItem 비교 로직이 필요하지만 원래 코드에는 동작이 없어서 생략
        setItems(filteredArray)
      } else if (sectionItem.label === '최근 본 상품 기반 카테고리 내 다른 상품 모듈') {
        const filteredArray = cartItem.filter((el: any) => !el.productName?.includes('100원샵'))
        setItems(filteredArray)
      } else {
        setItems(cartItem)
      }
    }
  }, [cartItem, sectionItem, hasAccessToken])

  return (
    <>
      {items.length !== 0 && (
        <>
          <div
            className='cart_items'
            onClick={(): void => {
              const gtmNavigateClick: DataLayerArgs = {
                dataLayer: {
                  event: 'select_content',
                  event_info: {
                    content_type: '홈모듈',
                    content_id: String(el.sectionNo),
                    content_name: el.sectionName,
                  },
                },
              }
              if (isAppView) {
                sendSetAppsflyerEvent({
                  eventName: 'select_content',
                  eventType: {
                    content_type: '홈모듈',
                    content_id: String(el.sectionNo),
                    content_name: el.sectionName,
                  },
                })
              } else {
                TagManager.dataLayer(gtmNavigateClick)
              }
            }}
          >
            <div className='home_module_title'>
              <p>{sectionItem?.promotionText}</p>
              <p>
                <strong>{sectionItem?.sectionExplain}</strong>
              </p>
            </div>
            <Swiper
              spaceBetween={8}
              slidesPerView={2.4391}
              breakpoints={{
                768: {
                  spaceBetween: 16,
                  slidesPerView: 5,
                },
              }}
            >
              {sectionItem?.label === '장바구니에 담긴 상품 모듈'
                ? hasAccessToken
                  ? cartItem?.orderProducts?.map((element: any, idx: number) => {
                      return (
                        <SwiperSlide key={idx}>
                          <CartItem
                            el={element}
                            key={element.productNo}
                            setLike={setLike}
                            label={sectionItem?.label}
                            priceData={priceData}
                            idx={idx}
                            category={category}
                            listId={el.sectionNo}
                            listName={el.sectionName}
                          ></CartItem>
                        </SwiperSlide>
                      )
                    })
                  : cartItem?.map((element: any, idx: number) => {
                      return (
                        <SwiperSlide key={idx}>
                          <CartItem
                            el={element}
                            key={element.productNo}
                            setLike={setLike}
                            label={sectionItem?.label}
                            priceData={[]}
                            idx={idx}
                            category={category}
                            listId={el.sectionNo}
                            listName={el.sectionName}
                          ></CartItem>
                        </SwiperSlide>
                      )
                    })
                : items?.map((element: any, idx: number) => {
                    return (
                      <SwiperSlide key={idx}>
                        <CartItem
                          el={element}
                          key={element?.productNo}
                          setLike={setLike}
                          label={sectionItem?.label}
                          priceData={[]}
                          idx={idx}
                          category={category}
                          listId={el.sectionNo}
                          listName={el.sectionName}
                        ></CartItem>
                      </SwiperSlide>
                    )
                  })}
            </Swiper>
            {index !== 0 && <hr />}
          </div>
        </>
      )}
    </>
  )
}
